import React from 'react';
import { Card, CardMedia, CardContent, makeStyles } from '@material-ui/core';
import { colorSet, clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import useUserActionLog from '@hooks/useUserActionLog';
import { CapaActivityType } from '@generated/graphql';
import { ProcessmethodCardProps } from './ProcessmethodCard';

export interface PcbServicetypeCardProps extends ProcessmethodCardProps {
  onClick: () => void;
  isSelected: boolean;
}

const PcbServicetypeCard: React.FC<PcbServicetypeCardProps> = ({
  img,
  label,
  english,
  onClick,
  isSelected = false,
  log
}) => {
  const { cardContainer, cardMedia, cardContent } = useStyles({
    isSelected
  });
  const { onInsertUserActionLogOne } = useUserActionLog();

  return (
    <Card
      className={clsx([
        cardContainer,
        {
          selected: isSelected
        }
      ])}
      onClick={() => {
        if (log) {
          onInsertUserActionLogOne(log, CapaActivityType.ButtonClick);
        }
        onClick();
      }}
    >
      <>
        <CardContent className={cardContent}>
          <CustomizedTypography
            variant={'body2'}
            fontWeight="500"
            color="textPrimary"
          >
            <i className="request-gtm-detailServiceType-btn">{label}</i>
          </CustomizedTypography>
          {english && (
            <CustomizedTypography variant={'subtitle2'} color="textSecondary">
              ({english})
            </CustomizedTypography>
          )}
        </CardContent>
        <CardMedia className={cardMedia} image={img} />
      </>
    </Card>
  );
};

export default PcbServicetypeCard;

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 241,
    width: 241,
    minHeight: 72,
    padding: '12px 16px',
    borderRadius: 12,
    boxShadow: 'unset',
    border: `1px solid ${colorSet.gray400}`,
    '&:hover': {
      backgroundColor: colorSet.gray100,
      cursor: 'pointer',
      '& .requestNow': {
        color: colorSet.primary500
      }
    },
    '&.selected': {
      border: `2px solid ${colorSet.gray900}`,
      padding: '11px 15px'
    },
    transition: '0.3s',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%'
    }
  },
  cardMedia: {
    minWidth: 48,
    maxHeight: 48,
    borderRadius: 8
  },
  cardContent: {
    padding: 0,
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& button': {
      '& span': {
        justifyContent: 'flex-start'
      },
      '&.text:hover': {
        backgroundColor: colorSet.gray400
      }
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  reccomendationCardContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colorSet.gray100,
    border: 'none',
    '& .reccomendationBox': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    '&:hover': {
      '& svg': {
        fill: colorSet.primary500
      }
    }
  }
}));
